module.exports = __webpack_public_path__ + "img/guide-zh-1.d3bd5cb0.png";